const storageNames = {
    MONDAY_DATA: "monday_data",
    TUESDAY_DATA: "tuesday_data",
    WEDNESDAY_DATA: "wednesday_data",
    THURSDAY_DATA: "thursday_data",
    FRIDAY_DATA: "friday_data",
    SATURDAY_DATA: "saturday_data",
    SUNDAY_DATA: "sunday_data",
}

export default storageNames